import 'angular';

import restButtonDirective from '../rest-button';

import addOptions from './add';

const MODULE_NAME = 'daupler.incidents.components.buttons.log';

var app = angular.module(MODULE_NAME, []);

app.directive('addLogEntry', restButtonDirective(addOptions));

export default MODULE_NAME;
